import React from 'react';

type RfqVersionTimelineNodeProps = {
  selected: boolean;
  prePortal?: boolean;
};

/** Circular node on the version timeline; filled when selected. */
const RfqVersionTimelineNode: React.FC<RfqVersionTimelineNodeProps> = ({
  selected,
  prePortal = false,
}) => (
  <span
    className={`srfq-timber-version-node${selected ? ' selected' : ''}${
      prePortal ? ' srfq-timber-version-node--pre-portal' : ''
    }`}
    aria-hidden
  />
);

export default RfqVersionTimelineNode;
